
import { defineComponent, ref, reactive, toRefs, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import Form from './Form.vue'
import actionChecker from './../../../../classes/action_checker'

export default defineComponent({
    components: {
        Form,
    },

    setup () {
        const form = reactive({
            id: '',
            name: '',
            code: '',
            address: '',
            business_unit_id: '',
        })

        const form_action = ref('save')
        const visible = ref(false)
        const store = useStore()
    
        const current_page = ref(1)
        const current_page_archive = ref(1)

        const fields = ref<any>([
        {
            title: 'Group',
            dataIndex: 'business_unit.name',
        },
        {
            title: 'Business Unit',
            dataIndex: 'name',
        },
        {
            title: 'Code',
            dataIndex: 'code',
        },
        {
            title: 'Site Address',
            dataIndex: 'address',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            slots: {customRender: 'action'},
            align: 'center'
        }
        ])

        const index = (payload = {page: 1}) => {
            payload.page = current_page.value;
            store.dispatch('Site/index', payload).then((res) => {
                if(current_page.value > res.data.last_page) {
                    current_page.value = res.data.last_page
                    index()
                }
            })
        }

        const indexArchive = (payload = {page: 1}) => {
            payload.page = current_page_archive.value;
            store.dispatch('Site/archive_lists', payload)
            .then((res) => {
                if(current_page_archive.value > res.data.last_page) {
                    current_page_archive.value = res.data.last_page
                    indexArchive()
                }
            })
        }

        const filterRecord = (payload: any) => {
            current_page.value = payload.page;
            index(payload)
        }

        const filterRecordArchives = (payload: any) => {
            current_page_archive.value = payload.page;
            indexArchive(payload)
        }

        const createRecord = () => {
            form_action.value = 'save'
            const { id, name, code, address, business_unit_id } = toRefs(form)
            id.value = ''
            name.value = ''
            code.value = ''
            address.value = ''
            business_unit_id.value = ''
            visible.value = true
        }

        const editRecord = (record:any) => {
            form_action.value = 'update'
            const { id, name, code, address, business_unit_id } = toRefs(form)
            id.value = record.id
            name.value = record.name
            code.value = record.code
            address.value = record.address
            business_unit_id.value = record.business_unit_id
            visible.value = true
        }

        const handleSaving = (record: any) => {
            form_action.value == 'save' ? storeRecord(record) : updateRecord(record)
        }

        const storeRecord = (payload = {}) => {
            store
                .dispatch('Site/store', payload)
                .then(() =>  {
                    visible.value = false
                    index()
                })
        }

        const updateRecord = (payload = {}) => {
            store
                .dispatch('Site/update', payload)
                .then(() =>  {
                    visible.value = false
                    index()
                })
        }

        const deleteRecord = (record: any) => {
            store.dispatch('Site/destroy', record.id)
            .then(() => {
                index()
                indexArchive()
            })
        }

        const restoreRecord = (record: any) => {
            store.dispatch('Site/restore', record.id)
            .then(() => {
                index()
                indexArchive()
            })
        }

        onMounted(() => {
            index()
            indexArchive()
        })

        const items = computed(() => store.getters['Site/items'])
        const archive_items = computed(() => store.getters['Site/archive_items'])
        const loading = computed(() => store.getters['Site/status'])
        const archive_loading = computed(() => store.getters['Site/archive_status'])

        return {
            items,
            archive_items,
            loading,
            archive_loading,
            filterRecord,
            filterRecordArchives,
            form,
            fields,
            form_action,
            visible,
            createRecord,
            editRecord,
            deleteRecord,
            restoreRecord,
            handleSaving,
            actionChecker
        }
    }

})
